import { Box, IconButton } from '@mui/material'
import React from 'react'
import SendIcon from '@mui/icons-material/Send'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import BarChartIcon from '@mui/icons-material/BarChart'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { borderFormat, mainGreen } from '../utils/color'

export default function CreateOrderButton(props) {
	const { currentUser } = useSelector((state) => state.currentUser)
	const navigate = useNavigate()
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				background: '#fff',
				borderTop: borderFormat,
				borderLeft: borderFormat,
			}}>
			<IconButton
				sx={{
					paddingLeft: '10px',
					paddingRight: 0,
				}}>
				<NoteAddIcon
					sx={{
						color: mainGreen,
						fontSize: '30px',
						cursor: 'pointer',
					}}
				/>
			</IconButton>
			<IconButton
				sx={{
					paddingLeft: 0,
					paddingRight: '5px',
				}}
				onClick={() => {
					if (currentUser.role === 'storeManager') {
						navigate('/store-manager/statistics')
					} else if (
						currentUser.role === 'admin' ||
						currentUser.role === 'director' ||
						currentUser.role === 'assistant'
					) {
						navigate('/admin/statistics')
					} else if (currentUser.permission?.includes('seeRevenue')) {
						navigate('/user/statistics')
					}
				}}>
				<BarChartIcon
					sx={{
						color: mainGreen,
						fontSize: '30px',
						cursor: 'pointer',
					}}
				/>
			</IconButton>
			<input
				style={{ marginLeft: 0, marginRight: 0 }}
				onClick={() => {
					props.setShowForm(true)
				}}
				id='input-websocket'
				type='text'
				placeholder='Tạo đơn hàng'
			/>
			<IconButton
				onClick={() => {
					props.setShowForm(true)
				}}>
				<SendIcon
					sx={{
						color: mainGreen,
						fontSize: '30px',
						cursor: 'pointer',
					}}
				/>
			</IconButton>
		</Box>
	)
}
